@if (loading) {
  <div class="global_spinner">
    <mat-progress-spinner color="mat-accent" mode="indeterminate" i18n-mode></mat-progress-spinner>
  </div>
}
